module.exports = __webpack_public_path__ + "static/media/S1N2-6.f34bfbc1.svg";